import React from "react";
import { Link } from "react-router-dom";
import "../styles/ThankYouPage.css";

function ThankYouPage() {
  return (
    <div className="thank-you-page">
 
      <h2><strong>Your house is now registered for the Holiday Lights Contest! </strong></h2>
      <p>Be sure to return on December 20 to vote for your favorite decorated houses.
Help spread the holiday cheer by inviting your neighbors to participate and vote!</p>
      <Link to="/" className="home-link">
        Return Home
      </Link>
    </div>
  );
}

export default ThankYouPage;
